export const createLabel = (className, text = ``) => {
  const label = document.createElement(`label`);
  label.className = className;
  label.innerHTML = text;

  return label;
};
